/**
 * AirlineDocTypeOverridesAdmin Page - Super Admin page for managing airline-specific doc type overrides
 *
 * Features:
 * - View all airline + doc type override combinations
 * - Create new overrides
 * - Edit existing overrides (all 10 retrieval parameters)
 * - Delete overrides (reverts to Tier 1 defaults)
 * - Three-tier parameter system (Tier 2)
 *
 * Permissions: Super Admin only (Global airline admin)
 */

import { useAirline } from '../../contexts/AirlineContext';
import AirlineDocTypeOverridesAdmin from '../../components/admin/AirlineDocTypeOverridesAdmin';

export default function AirlineDocTypeOverridesAdminPage() {
  const { isSuperAdmin } = useAirline();

  if (!isSuperAdmin) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h2>
          <p className="text-gray-600">You need super admin permissions to access this page.</p>
        </div>
      </div>
    );
  }

  return <AirlineDocTypeOverridesAdmin />;
}
